import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Route from './router';
import store from './store';
import { persistor } from './store'
import { PersistGate } from 'redux-persist/lib/integration/react';

import './config/rem'; //rem屏幕适配
import './config/wxSdk'; //引入wx sdk
import './assets/iconfont/iconfont.css'; //引入iconfont
import './assets/scss/common.scss'; //引入公共样式
let script = document.createElement('script');
script.type = 'text/javascript';
script.src = 'https://pv.sohu.com/cityjson?ie=utf-8';
document.getElementById('root').appendChild(script);
setTimeout(() => {
  window.sessionStorage.setItem("returnCitySN", window.returnCitySN.cname)
}, 2000)


const render = Component => {
  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Component />
      </PersistGate>
    </Provider>,
    document.getElementById('root')
  );
};

render(Route);

